import { createContext, useContext } from 'react';

export type ModalType = false | 'windowed' | 'fullscreen';

type Props = {
  children: React.ReactNode;
  value: ModalType;
};

const IsInModalContext = createContext<ModalType>(false);

export function IsInModalProvider({ value, children }: Props) {
  return (
    <IsInModalContext.Provider value={value}>
      {children}
    </IsInModalContext.Provider>
  );
}

export function useIsInModal() {
  const modalType = useContext(IsInModalContext);

  return {
    isInModal: modalType !== false,
    isFullScreen: modalType === 'fullscreen',
  };
}
